// extracted by mini-css-extract-plugin
export default {"sensors":"MonitoringData_sensors__OqmG6","sensor":"MonitoringData_sensor__CqKIf","minmaxTemperatureWrapper":"MonitoringData_minmaxTemperatureWrapper__o-pLX"};